import { render, staticRenderFns } from "./resultBi.vue?vue&type=template&id=c02af648&scoped=true&"
import script from "./resultBi.vue?vue&type=script&lang=js&"
export * from "./resultBi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c02af648",
  null
  
)

export default component.exports